import {css} from '@emotion/react';
import styled from '@emotion/styled';

export const ListControls = styled.div(
  ({theme}) => css`
    display: flex;
    justify-content: center;
    ${theme.spacing('marginTop', 'pages/small')};
  `
);
